interface GiftIconProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

export function GiftIcon({width, height, fill, className}: GiftIconProps) {
  return (
    <svg
      width={width ?? 17}
      height={height ?? 17}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.80358 3.16699C9.23636 3.16699 8.73281 3.4551 8.43321 3.89294C8.15171 3.59474 7.75415 3.40401 7.31466 3.40401C6.46793 3.40401 5.7739 4.09804 5.7739 4.94476C5.7739 5.24982 5.86352 5.53428 6.01837 5.77437H3.52208C3.3359 5.77437 3.1665 5.94376 3.1665 6.12994V8.26327C3.1665 8.44944 3.3359 8.61884 3.52208 8.61884H3.87765V13.4781C3.87765 13.6643 4.04705 13.8337 4.23323 13.8337H12.7665C12.9527 13.8337 13.1221 13.6643 13.1221 13.4781V8.61884H13.4777C13.6639 8.61884 13.8333 8.44945 13.8333 8.26327V6.12994C13.8333 5.94377 13.6639 5.77437 13.4777 5.77437H11.1628C11.3513 5.50518 11.4628 5.17774 11.4628 4.8262C11.4628 3.91399 10.7157 3.16699 9.80358 3.16699ZM9.80358 3.87814C10.3314 3.87814 10.7517 4.29844 10.7517 4.82631C10.7517 5.35418 10.3314 5.77447 9.80358 5.77447H8.85541V4.82631C8.85541 4.29846 9.27571 3.87814 9.80358 3.87814ZM7.3147 4.11516C7.77709 4.11516 8.1443 4.48239 8.1443 4.94476V5.77437H7.3147C6.85231 5.77437 6.48509 5.40713 6.48509 4.94476C6.48509 4.48239 6.85233 4.11516 7.3147 4.11516ZM3.87768 6.48552H8.14432V7.90771H3.87768V6.48552ZM8.85543 6.48552H13.1221V7.90771H8.85543V6.48552ZM4.58878 8.61884H8.14432V13.1225H4.58878V8.61884ZM8.85543 8.61884H12.411V13.1225H8.85543V8.61884Z"
        fill={fill ?? 'currentColor'}
      />
    </svg>
  );
}
